import Layout from "../components/Layout";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { BASE_URL } from "../utils/commonUrl";
import { useSelector } from "react-redux";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import QuarterNames from "../components/QuarterNames";
import { confirm } from "react-bootstrap-confirmation";
import { toast } from 'react-toastify'

const PromotionRecommendation = () => {
    const primeToast = useRef(null);
    const [start] = useState(0);
    const [empIdpList, setEmpIdpList] = useState([]);
    const { user } = useSelector((state) => state["auth"]);
    const [filters, setFilters] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [quarterName, setQuarterName] = useState("");
    const [confirmResult, setConfirmResult] = useState();
    const [isValidData, setIsValidData] = useState();

    const successNotify = (message) => toast.info(message);
    const errorNotify = (message) => toast.error(message);

    useEffect(() => {
        initFilters();
        getEmployeeIDPList(user.registerID, user.quarterID)
        setQuarterName(user.quarterName);
    }, [])


    const getEmployeeIDPList = async (registerID, quarterID) => {
        const _dbModel = { registerId: registerID, quarterId: parseInt(quarterID) }
        axios.post(BASE_URL + "/api/employeepromotion/GetEmployeePromotionList/", JSON.stringify(_dbModel))
            .then(response => {
                setEmpIdpList(response.data)
            })
            .catch(e => console.log(e))
    }
    const _actionIDPBody = (empIdp) => (<>     
        <div class="btn-group">
            <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                Select
            </button>
            <ul class="dropdown-menu" style={{ minWidth: "11rem" }}>
                <li><a style={{ fontWeight: "600" }} className="dropdown-item" href="#"
                    onClick={async () => { 
                        /*                                           
                        if(empIdp.isHODPromotionRecommend){                            
                            errorNotify("Error!! HOD Recommendation has been completed. You can not change.");
                            return;
                        } 
                            */
                           
                        //setConfirmResult(await confirm('Are you sure to recommend this employee?'));
                        //console.log("onClick result"+confirmResult);                          
                        //if (confirmResult === true) {
                        // console.log("confirmResult true");         
                        var e = document.getElementById("ddlQuarter");
                        var _selectedValue = e.value === "-1" ? user.quarterID : e.value;
                        //await isValidForSave(empIdp.registerID, _selectedValue, 0);
                        //console.log(isValidData);
                        //if (isValidData.data.isValid === 0) {
                          //  errorNotify("Error!! Recommendation has been completed. You can not change.");
                           // return;
                       // }
                        savePromotionRecommendation(empIdp.registerID, _selectedValue, 1);
                        //}
                    }}><i class="bi bi-pencil-fill"></i> Promotion Recommendation</a>
                </li>
                <li><a style={{ fontWeight: "600" }} className="dropdown-item" href="#"
                    onClick={async () => {
                        /*
                        if(empIdp.isHODPromotionRecommend){                            
                            errorNotify("Error!! HOD Recommendation has been completed. You can not change.");
                            return;
                        } 
                        */

                        //setConfirmResult(await confirm('Are you sure to hold promotion to this employee?'));
                        //if (confirmResult === true) {
                        var e = document.getElementById("ddlQuarter");
                        var _selectedValue = e.value === "-1" ? user.quarterID : e.value;
                        savePromotionRecommendation(empIdp.registerID, _selectedValue, 2);
                        //}
                    }}><i class="bi bi-person-lines-fill"></i> Hold Promotion</a>
                </li>
                <li><a style={{ fontWeight: "600" }} className="dropdown-item" href="#"
                    onClick={async () => {
                        if(empIdp.isHODPromotionRecommend){
                            //console.log("isPromotionRecommend");                          
                            errorNotify("Error!! HOD Recommendation has been completed. You can not change.");
                            return;
                        } 
                        //setConfirmResult(await confirm('Are you sure not to recommend promotion to this employee?'));
                        //if (confirmResult === true) {
                        var e = document.getElementById("ddlQuarter");
                        var _selectedValue = e.value === "-1" ? user.quarterID : e.value;
                        savePromotionRecommendation(empIdp.registerID, _selectedValue, 3);
                        //}
                    }}><i class="bi bi-person-lines-fill"></i> Not Recommended</a>
                </li>
            </ul>
        </div>
        {/* <button type="button" style={{cursor: "pointer",padding:"2px 5px 2px 5px", fontSize:"10pt"}} className="btn btn-outline-secondary" onClick={()=>{
            window.open("https://apps.bitopibd.com/BIMOBApps/PMSReport/IndividualPerformanceReport?RegisterID=" + empIdp.registerID);
        }}>IDP Report</button> */}
    </>)

    const isValidForSave = async (registerID, quarterID, headTypeId) => {
        console.log("isvalid");         
        const _dbModel = { registerId: registerID, quarterId: parseInt(quarterID), headTypeId: parseInt(headTypeId) }
        axios.post(BASE_URL + "/api/employeepromotion/IsValidForSave/", JSON.stringify(_dbModel))
            .then(response => {
                console.log(response);
                setIsValidData(response.data);
            })
            .catch(e => console.log(e))
    }

    const savePromotionRecommendation = async (registerID, quarterID, recommendationStatus) => {
        //console.log("save");         
        const _dbModel = { registerId: registerID, quarterId: parseInt(quarterID), recommendationStatus: parseInt(recommendationStatus), recommenderRegisterID: parseInt(user.registerID), addedBy: user.registerID.toString() }
        axios.post(BASE_URL + "/api/employeepromotion/SavePromotionRecommendation/", JSON.stringify(_dbModel))
            .then(response => {
                //console.log(response);               
                if (response.status === 200) {
                    successNotify("Data saved successfully.");
                    getEmployeeIDPList(user.registerID, user.quarterID)
                }
            })
            .catch(e => console.log(e))
    }

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    }


    const initFilters = () => {
        setFilters({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            'employeeCode': {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
            },
            'employeeName': {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
            },
            'department': {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
            },
            'designation': {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
            },
        });
        setGlobalFilterValue('');
    }
    const clearFilter = () => {
        initFilters();
    }

    const header = (
        <div className="table-header">
            <div className='d-flex justify-content-between'>
                <div>
                    <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined"
                        onClick={clearFilter} />
                    <span className="p-input-icon-left"> <i className="pi pi-search" />
                        <InputText value={globalFilterValue} onChange={onGlobalFilterChange}
                            placeholder="Keyword Search" />
                    </span>
                </div>
            </div>
        </div>
    );

    const childToParent = () => {
        var e = document.getElementById("ddlQuarter");
        var _selectedValue = e.value === "-1" ? user.quarterID : e.value;
        setQuarterName(e.value === "-1" ? user.quarterName : e.options[e.selectedIndex].text);
        getEmployeeIDPList(user.registerID, _selectedValue);
    }


    return (<Layout>

        <div className="card mt-2">
            <div className="card-header d-flex justify-content-between">
                <h6><i class="bi bi-person-check"></i> Employee List</h6>
                <h4> <QuarterNames childToParent={childToParent} hidden={true} /></h4>
            </div>
            <div className="card-body">
                <DataTable value={empIdpList} header={header} paginator rows={7} first={start}
                    globalFilterFields={['employeeCode', 'employeeName', 'department', 'designation']}
                    filters={filters}
                    dataKey="registerID" paginatorTemplate=" PageLinks  ">
                    <Column field="registerID" header="registerID" hidden={true} />
                    <Column field='employeeCode' style={{ width: "13%" }} sortable alignHeader="center" header="Emp Code" />
                    <Column field='employeeName' sortable alignHeader="center" header="Employee Name" />
                    <Column field='department' sortable alignHeader="center" header="Department" />
                    <Column field='designation' sortable alignHeader="center" header="Designation" />
                    <Column field='isPromotionRecommend' sortable alignHeader="center" header="Designation" hidden={true} />
                    <Column field='recommendationStatus' sortable alignHeader="center" header="Designation" hidden={true} />
                    <Column field='recommendationStatusDetail' sortable alignHeader="center" style={{ fontWeight: "bold" }} header="Status" />
                    <Column field="registerID" style={{ width: "10%" }} align="center" alignHeader="center" header="Action" body={_actionIDPBody} />
                </DataTable>
            </div>
        </div>

    </Layout>)
}


export default PromotionRecommendation